import React, { Component } from 'react'
import Video from './Video'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Landingpage from './components/Landingpage'

class App extends Component {
	render() {
		return (
			<div>
				<Router>
					<Switch>
						<Route path="/" exact component={Landingpage} />
						<Route path="/:url" component={Video} />	
					</Switch>
				</Router>
			</div>
		)
	}
}

export default App;

